import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  VStack,
  Grid,
  GridItem,
  Text,
  Card,
  CardBody,
  HStack,
  Icon,
  List,
  ListItem,
  ListIcon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Link
} from '@chakra-ui/react';
import { AddIcon, CheckCircleIcon, LockIcon } from '@chakra-ui/icons';
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

class GuestWelcome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobileMenuOpen: false
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }}
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = "guest"
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p="10px"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p={8} maxW="1200px" mx="auto" flex="1">
          <VStack spacing={8} align="stretch">
            {/* Welcome Header */}
            <Box textAlign="center">
              <Heading as="h1" size="2xl" color={colors.primary.main} mb={4}>
                Welkom, Utrechter!
              </Heading>
              <Text fontSize="xl" color={colors.text.secondary}>
                Je bent ingelogd als gastgebruiker
              </Text>
            </Box>

            {/* Info Alert */}
            <Alert
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              borderRadius="lg"
              py={6}
              bg="white"
              border="2px solid"
              borderColor="gray.400"
              shadow="md"
            >
              <AlertIcon boxSize="40px" mr={0} color={colors.primary.main} />
              <AlertTitle mt={4} mb={2} fontSize="lg" color="gray.800">
                Wat is de gastmodus?
              </AlertTitle>
              <AlertDescription maxWidth="sm" fontSize="md" color="gray.600">
                Als gast kun je suggesties indienen zonder een account aan te maken.
                Je hoeft alleen je email in te vullen bij het indienen van een suggestie.
              </AlertDescription>
            </Alert>

            {/* How It Works */}
            <Card bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
              <CardBody>
                <VStack align="start" spacing={4}>
                  <Heading as="h3" size="md" color={colors.text.primary}>
                    Hoe werkt het?
                  </Heading>

                  <List spacing={3}>
                    <ListItem>
                      <HStack align="start">
                        <Text fontWeight="bold" color={colors.primary.main}>1.</Text>
                        <Text>
                          Klik op <strong>"Indienen"</strong> in de zijbalk om een suggestie in te dienen
                        </Text>
                      </HStack>
                    </ListItem>
                    <ListItem>
                      <HStack align="start">
                        <Text fontWeight="bold" color={colors.primary.main}>2.</Text>
                        <Text>
                          Schrijf je suggestie en klik op <strong>"Suggestie Indienen"</strong>
                        </Text>
                      </HStack>
                    </ListItem>
                    <ListItem>
                      <HStack align="start">
                        <Text fontWeight="bold" color={colors.primary.main}>3.</Text>
                        <Text>
                          Je suggestie wordt direct verzonden naar de vertegenwoordigers
                        </Text>
                      </HStack>
                    </ListItem>
                  </List>
                </VStack>
              </CardBody>
            </Card>

            {/* Two Column Layout */}
            <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={6}>
              
              {/* What You CANNOT Do */}
              <Card bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardBody>
                  <VStack align="start" spacing={4}>
                    <HStack>
                      <Icon as={LockIcon} color="orange.500" boxSize={6} />
                      <Heading as="h3" size="md">
                        Wat je NIET kunt doen (account nodig)
                      </Heading>
                    </HStack>

                    <List spacing={3}>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={LockIcon} color="orange.500" mt={1} />
                          <Text>
                            <strong>Je eigen suggesties bekijken</strong> - Zonder account kun je je eerdere suggesties niet terugzien
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={LockIcon} color="orange.500" mt={1} />
                          <Text>
                            <strong>Suggesties bewerken of verwijderen</strong> - Dit vereist een account voor verificatie
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={LockIcon} color="orange.500" mt={1} />
                          <Text>
                            <strong>Berichten ontvangen</strong> - Communicatie met vertegenwoordigers vereist een account
                          </Text>
                        </HStack>
                      </ListItem>
                    </List>

                    <Button
                      variant="outline"
                      colorScheme="blue"
                      size="lg"
                      width="full"
                      onClick={() => this.props.onRouteChange('register')}
                      borderColor={colors.primary.main}
                      color={colors.primary.main}
                      _hover={{ bg: colors.primary.light }}
                    >
                      Account Aanmaken
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
              
              {/* What You CAN Do */}
              <Card bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardBody>
                  <VStack align="start" spacing={4}>
                    <HStack>
                      <Icon as={CheckCircleIcon} color="green.500" boxSize={6} />
                      <Heading as="h3" size="md">
                        Wat je WEL kunt doen
                      </Heading>
                    </HStack>

                    <List spacing={3}>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Suggesties indienen</strong> - Deel je ideeën en voorstellen
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Meerdere suggesties indienen</strong> - Je kunt zoveel suggesties indienen als je wilt tijdens deze sessie
                          </Text>
                        </HStack>
                      </ListItem>
                    </List>

                    <Button
                      leftIcon={<AddIcon />}
                      colorScheme="blue"
                      size="lg"
                      width="full"
                      onClick={() => this.props.onRouteChange('indienen')}
                      bg={colors.button.primary}
                      _hover={{ bg: colors.button.primaryHover }}
                      _active={{ bg: colors.button.primaryActive }}
                    >
                      Suggestie Indienen
                    </Button>
                  </VStack>
                </CardBody>
              </Card>

              
            </Grid>

            

            {/* Privacy Notice */}
            <Alert status="warning" borderRadius="lg">
              <AlertIcon />
              <Box>
                <AlertTitle>Privacy</AlertTitle>
                <AlertDescription>
                  Je emailadres wordt opgeslagen bij je suggesties en is zichtbaar voor vertegenwoordigers.
                  Door te blijven gebruiken ga je akkoord met ons{' '}
                  <Link
                    color={colors.text.link}
                    fontWeight="600"
                    textDecoration="underline"
                    onClick={() => this.props.onRouteChange('privacyPolicy')}
                    cursor="pointer"
                    _hover={{ color: colors.text.linkHover }}
                  >
                    Privacybeleid
                  </Link>
                  {' '}en onze{' '}
                  <Link
                    color={colors.text.link}
                    fontWeight="600"
                    textDecoration="underline"
                    onClick={() => this.props.onRouteChange('termsOfService')}
                    cursor="pointer"
                    _hover={{ color: colors.text.linkHover }}
                  >
                    Algemene Voorwaarden
                  </Link>.
                </AlertDescription>
              </Box>
            </Alert>
          </VStack>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state?.userVersion || 'guest'}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

export default GuestWelcome
